/* eslint-disable import/no-extraneous-dependencies */
import { FileModel, LoginUser } from "@aecom/core";
import { DefaultSelection36CorrespondenceIssuedPayload, ICorrListItem, IUser } from "@api";
import { ICorrDocumentDownload } from "@api/model/iCorrDocumentDownload";
import CorrespondenceStatus from "@models/CorrespondenceStatus";
import CorrespondenceRole from "@models/CorrespondenceRole";
import LocalContractUserService from "@services/local-contractUser.service";
import { RowItem } from "@bbj/components";
import _ from "lodash";


export function getDateFormatted_MMDDYYYY(date: Date | string): string {
  const offset = new Date(date).getTimezoneOffset();
  const d = new Date(new Date(date).setUTCMinutes(offset));
  const year = d.getFullYear();
  const month = (1 + d.getMonth()).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");

  return `${month}/${day}/${year}`;
}

// export function mappingFiles(documents: ICorrespondenceDocumentDownload[]): FileModel[] {
//     return documents
//       .map((docs) => {
//         return new FileModel(docs.Guid,
//             docs.FileName,
//             docs.DateCreated,
//             docs.URL,
//             "preloaded",
//             0,
//             null,
//             docs.DownloadURL);
//       })
//       .sort((a, b) => {
//         return new Date(b.Base64).getTime() - new Date(a.Base64).getTime();
//       });
//   }

export function emailValidation(email: string | undefined): boolean {
  // eslint-disable-next-line security/detect-unsafe-regex
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email && email.trim() !== "" ? re.test(email.toLowerCase()) : true;
}

export function zipValidation(zip: string | undefined): boolean {
  return zip && zip.trim() !== "" ? /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip) : true;
}

export function isSystemFields(field: string): boolean {
  return (
    field === "Guid" ||
    field === "IsDraft" ||
    field === "DateCreated" ||
    field === "CreatedBy" ||
    field === "DateUpdated" ||
    field === "UpdatedBy" ||
    field === "DateDeleted" ||
    field === "DeletedBy"
  );
}

export function generateUserRowItem<T>(item: T & { UserInfo?: IUser }, extraProperties?: Partial<RowItem>): RowItem {
  let organization = "";

  if (item.UserInfo?.department) {
    const nameArray = item.UserInfo.department.split(" ");

    if (nameArray) {
      [organization] = nameArray;
    }
  }
  return {
    id: item.UserInfo.id,
    name: item.UserInfo.displayName ?? "",
    email: item.UserInfo.mail ?? "",
    organization,
    track: item.UserInfo.department ?? "",
    checked: false,
    ...extraProperties,
  };
}

export function combineUserInfo<T>(item: T, user?: IUser): T & { UserInfo?: IUser } {
  return { ...item, UserInfo: user };
}

export function getDate(date?: string | null): string {
  if (!date) {
    return "-";
  }
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric"
  } as Intl.DateTimeFormatOptions;

  const tempDate = new Date(date.replace("00:00:00.000Z", "12:00:00.000Z"));

  return tempDate.toLocaleDateString(undefined, options).replace(", ", "-").replace(" ", "-");
}

export function getFormatedDate(date: string): string {
  return `${new Date(date)
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    })
    .replace(", ", "-")
    .replace(" ", "-")} ${new Date(date).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit"
  })}`;
}

export function getStatusText(status: string, isDB = false): string {
  switch (status) {
    case CorrespondenceStatus.Draft:
    case CorrespondenceStatus.Filed:
    case CorrespondenceStatus.Responded:
    case CorrespondenceStatus.Response_Requested:
      return status;
    case CorrespondenceStatus.In_Review:
    case CorrespondenceStatus.Issued:
      return isDB ? CorrespondenceStatus.Issued : status;
    default:
      return status;
  }
}

function getIconStr(iconname: string): string {
  return `icon icon-purple icon-lg ${iconname}`;
}

export function getIcon(status, isDB = false): string | null {
  switch (status) {
    case CorrespondenceStatus.Draft:
      return getIconStr("icon-action_write");
    case CorrespondenceStatus.Issued:
      return getIconStr("icon-action_send");
    case CorrespondenceStatus.In_Review:
      return isDB ? getIconStr("icon-action_send") : getIconStr("icon-action_rotate_anticlockwise");
    case CorrespondenceStatus.Responded:
      return getIconStr("icon-action_special");
    case CorrespondenceStatus.Filed:
      return getIconStr("icon-action_check_circle");
    case CorrespondenceStatus.Void:
      return getIconStr("icon-action_remove_circle");
    default:
      return null;
  }
}

export function isFinalStep(status: string): boolean {
  return status === CorrespondenceStatus.Responded || status === CorrespondenceStatus.Filed;
}

export function getFilesByType(documents: ICorrDocumentDownload[], documentType?: string): FileModel[] {
  const documnetsForThis =  documents
    .filter((item) => {
      return documentType ? item.FileType === documentType : true;
    })
    .map((docs) => {
      return new FileModel(
        docs.Guid,
        docs.FileName,
        docs.DateCreated,
        docs.URL,
        "preloaded",
        0,
        null,
        docs.DownloadURL,
        docs.Size
      );
    });
  return _.uniqBy(
    documnetsForThis.sort((a, b) => {
      return new Date(b.Base64).getTime() - new Date(a.Base64).getTime();
    }),
    "Name",
  );
}

export function getDateWithOffSet(date: string | null): string {
  if (!date) return null;
  const tempDate = new Date(date.replace("00:00:00.000Z", "12:00:00.000Z"));
  return tempDate.toLocaleDateString();
}

export function getNavigationUrl(item: ICorrListItem): string {
  let key = "view";
  if (item.ViewOnly !== true) {
    switch (item.Status) {
      case CorrespondenceStatus.Draft:
        key = "create";
        break;
      case CorrespondenceStatus.In_Review:
        key = "inReview";
        break;
      case CorrespondenceStatus.Issued:
        key = "issued";
        break;
      default:
        break;
    }
  }
  return `${item.ContractId}/${key}/${item.Guid}`;
}

export function validDBViewPermission(items: ICorrListItem[], localContractUserService: LocalContractUserService, user: LoginUser): ICorrListItem[] {
  const contractRole = localContractUserService.currentUserContractRole;
  if (contractRole === CorrespondenceRole.DBAdmin) {
    return items.filter((item) => {
      const fromId =
        item.correspondence_create
          ?.correspondence_reference_user_correspondence_create_FromTocorrespondence_reference_user
          ?.UserId;
      const fromUserRole = localContractUserService.getUserRoleId(fromId);
      const toId =
        item.correspondence_create
          ?.correspondence_reference_user_correspondence_create_ToTocorrespondence_reference_user
          ?.UserId;
      const toUserRole = localContractUserService.getUserRoleId(toId);
      const createBy = item.correspondence_create?.UpdatedBy;
      const originatorUserRole = localContractUserService.getUserRoleId(createBy);
      return fromUserRole === CorrespondenceRole.DBAdmin || toUserRole === CorrespondenceRole.DBAdmin || originatorUserRole === CorrespondenceRole.DBAdmin;
    });
  } else if(contractRole === CorrespondenceRole.SA_User)
  {
    return items.filter((item) => {
      return item.correspondence_cc_user && item.correspondence_cc_user.map((cc) => cc.UserId).includes(user.Id);
    });
  }
  return items;
}

export function getLastestIssuedItem(item?: ICorrListItem): DefaultSelection36CorrespondenceIssuedPayload | null {
  if(item?.correspondence_issued.length > 0)
  {
    return item.correspondence_issued.sort(
      (a, b) =>
        new Date(b.DateUpdated).getTime() - new Date(a.DateUpdated).getTime(),
    )[0];
  } 
  return null;
}

export function convertDateToUTCIOSString(date: Date | string): string {
  return new Date(new Date(date).setUTCHours(0)).toISOString();
}

export function isValidUUID(id: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);
}